// extracted by mini-css-extract-plugin
module.exports = {"service":"service--2wC2a","contactBlock":"contactBlock--1-aQh","foreign":"foreign--3h0GN","theme":"theme--37kqS"};